module.exports = __webpack_public_path__ + "static/img/mjfPurpose2.017b801.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mjfPurpose2.png
// module id = MAOI
// module chunks = 2